import { AvailabilityInfo } from '@/ui/components/AttractionsContent/core/AvailabilityInfo';
import { ArrowRightIcon } from '../Icons/ArrowRightIcon';
import { getFormattedPrice } from '@/service/utils/getFormattedPrice';
import { cn } from '@/service/utils/cn';
import { getCommonPhoneFormatURI } from '@/service/utils/getCommonPhoneFormat';

type TScheduleProps = {
    id: number;
    time: string;
    ticketsAvail: number;
    description: string;
    callToBooking: boolean;
    phone: string;
    price?: number;
    minTickets?: number;
    handler: (id: number) => void;
};

export const Schedule = ({
    id,
    time,
    ticketsAvail,
    price,
    minTickets,
    handler,
    description,
    callToBooking,
    phone,
}: TScheduleProps) => {
    return (
        <li className="relative mb-3 w-full" data-test-id="schedules-item">
            <button
                type="button"
                className="flex h-[65px] w-full items-center justify-between gap-x-1 overflow-hidden rounded-2xl border border-gray-2 pl-3 pr-3 dark:border-gray-3"
                onClick={() =>
                    callToBooking
                        ? (document.location.href = getCommonPhoneFormatURI(phone))
                        : handler(id)
                }
            >
                {
                    <div className="flex flex-nowrap items-center">
                        <span
                            data-test-id="schedule-time"
                            className="tx-medium-medium h-[52px] w-[52px] flex-shrink-0 rounded-lg bg-ash py-2 text-gray-2 dark:bg-blue-main dark:text-gray-3 md:py-1.5"
                        >
                            {time ? time.slice(0, time.length - 2) : 'All'}
                            <br />
                            {time ? time.slice(-2).toUpperCase() : 'Day'}
                        </span>
                        <div className={cn('flex', description ? 'mb-5' : '')}>
                            {!!price && (
                                <span
                                    data-test-id="schedule-price"
                                    className="ml-2 flex-shrink-0 rounded-2xl bg-brand-light px-4 py-1 text-xl font-medium leading-[22px] text-gray-2 dark:bg-brand-dark dark:text-gray-3"
                                >
                                    {getFormattedPrice(price)}
                                </span>
                            )}
                            {!callToBooking && (
                                <AvailabilityInfo
                                    className="ml-2 mt-0 h-[30px] w-max px-3.5 dark:bg-brand-dark [&_span]:text-sm [&_span]:leading-5 [&_svg]:h-3.5 [&_svg]:w-3.5"
                                    ticketsAvail={ticketsAvail ?? 0}
                                />
                            )}
                            {callToBooking && (
                                <div className="tx-medium-medium ml-1 flex w-fit items-center whitespace-nowrap rounded-2xl border border-brand bg-ash pr-4 text-gray-2 dark:bg-blue-main dark:text-gray-3">
                                    <div className="h-7 w-7 min-w-[28px] rounded-2xl bg-brand pl-0.5 pt-0.5">
                                        <img
                                            src="/icon/CallWhite.svg"
                                            alt="Call"
                                            height="22px"
                                            width="22px"
                                        />
                                    </div>
                                    <span className="ml-1.5">Call to book</span>
                                </div>
                            )}
                        </div>
                        {!!description && (
                            <span className="tx-medium-medium absolute bottom-1.5 left-20 z-[2] whitespace-nowrap text-gray-2 dark:text-gray-3 md:bottom-1 md:left-[74px] md:max-w-[232px] md:overflow-hidden md:text-ellipsis md:text-[12px]">
                                {description}
                            </span>
                        )}
                    </div>
                }
                {!callToBooking && (
                    <div className="relative flex w-full max-w-[120px] items-center justify-end">
                        <div className="z-[1] flex h-[34px] w-[18px] items-center justify-center bg-white shadow-[0_0_16px_16px_rgba(255,255,255,1)] dark:bg-dark-3 dark:shadow-[0_0_16px_16px_rgba(41,56,71,1)]">
                            <ArrowRightIcon className="h-[50%] w-[50%] [&_path]:fill-gray-3" />
                        </div>
                    </div>
                )}
            </button>
            {!!minTickets && minTickets > 1 && minTickets <= ticketsAvail && (
                <div className="tx-medium-medium absolute -top-2 right-0 z-10 mx-4 rounded-2xl border border-gray-2 bg-sand px-2 text-center text-gray-2 md:tx-normal-medium dark:border-gray-3 dark:bg-dark-1 dark:text-gray-3">
                    {`${minTickets} ticket minimum`}
                </div>
            )}
        </li>
    );
};
